import React, { useState } from 'react'
import styled from 'styled-components'

const Div = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100000;
`

const BreakpointWrapper = styled.div`
  display: ${props => (props.breakpointsAreVisible ? 'block' : 'none')};
`

const ScreenWrapper = styled.div`
  display: ${props => (props.screensAreVisible ? 'block' : 'none')};
`

const Breakpoint = styled.div`
  position: fixed;
  text-align: right;
  color: red;
  padding: 4px;
  font-weight: 700;
  font-size: 12px;
  box-sizing: border-box;
  border-right: 1px solid red;
  z-index: 100000;
  height: 100vh;
  width: ${props => props.width};
  &::before {
    content: '${props => props.name}';
  }
  pointer-events: none;
`

const Screen = styled.div`
  position: fixed;
  text-align: right;
  color: blue;
  padding: 4px;
  font-weight: 700;
  font-size: 12px;
  box-sizing: border-box;
  border-right: 1px solid blue;
  border-bottom: 1px solid blue;
  z-index: 100000;
  height: ${props => props.height};
  width: ${props => props.width};
  &::before {
    content: '${props => props.name}';
  }
  pointer-events: none;
`

const Button = styled.button`
  position: absolute;
  z-index: 100001;
  margin: 4px;
  background: white;
  border: none;
  outline: none;
  color: red;
  font-weight: 700;
  font-size: 12px;
  padding: 0 4px;
  opacity: 0;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  &:hover {
    opacity: 1;
    background: white;
  }
  :focus {
    outline: none;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  }
`

const Button2 = styled(Button)`
  top: 22px;
  left: 0;
  color: blue;
`

const ResponsiveHelper = () => {
  const [breakpointsAreVisible, setBreakpointsVisible] = useState(false)
  const [screensAreVisible, setScreensVisible] = useState(false)
  const [breakpointsButtonLabel, setBreakpointsButtonLabel] = useState(
    'SHOW BREAKPOINTS'
  )
  const [screensButtonLabel, setScreensButtonLabel] = useState(
    'SHOW SCREEN SIZES'
  )

  const toggleBreakpointsVisibility = () => {
    setBreakpointsVisible(!breakpointsAreVisible)
    breakpointsAreVisible
      ? setBreakpointsButtonLabel('SHOW BREAKPOINTS')
      : setBreakpointsButtonLabel('HIDE BREAKPOINTS')
  }

  const toggleScreensVisibility = () => {
    setScreensVisible(!screensAreVisible)
    screensAreVisible
      ? setScreensButtonLabel('SHOW SCREENS')
      : setScreensButtonLabel('HIDE SCREENS')
  }

  return (
    <Div>
      <Button type="button" tabIndex="-1" onClick={toggleBreakpointsVisibility}>
        {breakpointsButtonLabel}
      </Button>
      <Button2 type="button" tabIndex="-1" onClick={toggleScreensVisibility}>
        {screensButtonLabel}
      </Button2>
      <BreakpointWrapper breakpointsAreVisible={breakpointsAreVisible}>
        <Breakpoint width="24rem" name="XS" />
        <Breakpoint width="40rem" name="SM" />
        <Breakpoint width="56rem" name="MD" />
        <Breakpoint width="80rem" name="LG" />
        <Breakpoint width="112rem" name="XL" />
      </BreakpointWrapper>
      <ScreenWrapper screensAreVisible={screensAreVisible}>
        <Screen width="375px" height="667px" name="iPhone" />
        <Screen width="768px" height="1024px" name="iPad" />
        <Screen width="1280px" height="699px" name="MBP" />
        <Screen width="1680px" height="949px" name="MBP scaled" />
        <Screen width="2560px" height="1339px" name="Dell" />
      </ScreenWrapper>
    </Div>
  )
}

export default ResponsiveHelper
